
exports.purchaseUserStatus = function(user) {
  // return
  // 0: 未登録
  // 1: 有効なユーザー
  // 2: トライアル
  // 3: トライアル終了でキャンセル済み
  // 4: キャンセル済み（期間残りあり）
  // 5: 期限切れ 閲覧権限なし
  if (!user) {
    console.log("ユーザーなし")
    return 0;
  }

  // トライアルかどうか
  if (new Date() <= new Date(user.trialAt)) {
    // status がキャンセル済みなら、トライアル期間で終了
    console.log(`トライアル: ${(user.status === 2) ? "キャンセル済み" : "有効"}`)
    return (user.status === 2) ? 3 : 2;
  }
  // 支払い有効で、期限切れチェック
  else if (user.status === 1) {
    console.log(`課金中: ${(new Date() <= new Date(user.periodAt)) ? "有効" : "期限切れ"}`)
    return (new Date() <= new Date(user.periodAt)) ? 1 : 5;
  }
  // 支払いはキャンセルだけど、有効期限が残っている
  else if (user.status === 2) {
    console.log(`キャンセル済み: ${(new Date() <= new Date(user.periodAt)) ? "期限残りあり" : "期限切れ"}`)
    return (new Date() <= new Date(user.periodAt)) ? 4 : 5;
  }
  // その他
  else {
    console.log("無効")
    return 0;
  }
}

exports.getDateByString = function(dateStr) {
  const day = getYmd(dateStr);
  return new Date(day.y, day.m -1, day.d, day.h, day.mi);
}

exports.formatDateFromISO = function (dateStr, isTime = false) {
  const day = new Date(dateStr);

  return isTime ? `${day.getFullYear()}/${day.getMonth() + 1}/${day.getDate()} ${( '00' + day.getHours() ).slice( -2 )}:${( '00' + day.getMinutes() ).slice( -2 )}` : `${day.getFullYear()}/${day.getMonth() + 1}/${day.getDate()}`;
}

exports.formatDate = function (dateStr, exceptTime = false) {
  const day = getYmd(dateStr);

  return exceptTime ? `${day.m}/${day.d}` : `${day.m}/${day.d} ${day.h}:${day.mi}`;
}

exports.formatWeekDay = function(dateStr) {
  const dayJa = dayJaList();
  const day = getYmd(dateStr);

  const date = new Date(day.y, day.m -1, day.d);
  const dayOfWeek = date.getDay();
  return dayJa[dayOfWeek];
}

exports.formatHour = function(dateStr) {
  const day = getYmd(dateStr);
  return `${day.h}時`;
}

exports.stringFromDate = function(dateStr) {
  const day = getYmd(dateStr);
  return new Date(day.y, day.m-1, day.d);
}

exports.getCurrentDateString = function() {
  const day = new Date();

  const month = day.getMonth() + 1;
  return `${day.getFullYear()}${( '00' + month ).slice( -2 )}${( '00' + day.getDate() ).slice( -2 )}`;
}

exports.formatDirection = function(dir) {
  if (11.25 * 1 <= dir && dir < 11.25 * 3)
    return "北北東";
  else if (11.25 * 3 <= dir && dir < 11.25 * 5)
    return "北東";
  else if (11.25 * 5 <= dir && dir < 11.25 * 7)
    return "東北東";
  else if (11.25 * 7 <= dir && dir < 11.25 * 9)
    return "東";
  else if (11.25 * 9 <= dir && dir < 11.25 * 11)
    return "東南東";
  else if (11.25 * 11 <= dir && dir < 11.25 * 13)
    return "南東";
  else if (11.25 * 13 <= dir && dir < 11.25 * 15)
    return "南南東";
  else if (11.25 * 15 <= dir && dir < 11.25 * 17)
    return "南";
  else if (11.25 * 17 <= dir && dir < 11.25 * 19)
    return "南南西";
  else if (11.25 * 19 <= dir && dir < 11.25 * 21)
    return "南西";
  else if (11.25 * 21 <= dir && dir < 11.25 * 23)
    return "西南西";
  else if (11.25 * 23 <= dir && dir < 11.25 * 25)
    return "西";
  else if (11.25 * 25 <= dir && dir < 11.25 * 27)
    return "西北西";
  else if (11.25 * 27 <= dir && dir < 11.25 * 29)
    return "北西";
  else if (11.25 * 29 <= dir && dir < 11.25 * 31)
    return "北北西";
  else
    return "北";
}

exports.formatDirectionArrowStyle = function(dir) {
  return {transform:  `rotate(${dir}deg)`}
}

exports.colorWindPower = function(power) {
  const h = parseFloat(power);

   if (h === 0.0)
    return {color: `rgb(0,0,123)`};
   else if (h <= 0.5)
    return {color: `rgb(0,26,115)`};
   else if (h <= 1.0)
    return {color: `rgb(0,53,107)`};
   else if (h <= 1.5)
    return {color: `rgb(0,79,99)`};
   else if (h <= 2.0)
    return {color: `rgb(0,105,91)`};
   else if (h <= 2.5)
    return {color: `rgb(0,132,83)`};
   else if (h <= 3.0)
    return {color: `rgb(0,158,75)`};
   else if (h <= 3.5)
    return {color: `rgb(0,184,67)`};
   else if (h <= 4.0)
    return {color: `rgb(25,196,58)`};
   else if (h <= 4.5)
    return {color: `rgb(58,204,49)`};
   else if (h <= 5.0)
    return {color: `rgb(91,211,40)`};
   else if (h <= 5.5)
    return {color: `rgb(124,218,31)`};
   else if (h <= 6.0)
    return {color: `rgb(156,226,22)`};
   else if (h <= 6.5)
    return {color: `rgb(189,233,13)`};
   /*
   else if (h <= 7.0)
    return {color: `rgb(222,241,4)`};
   else if (h <= 7.5)
    return {color: `rgb(240,228,0)`};
   else if (h <= 8.0)
    return {color: `rgb(242,197,0)`};
  */
   else if (h <= 8.5)
    return {color: `rgb(245,165,0)`};
   else if (h <= 9.0)
    return {color: `rgb(247,133,0)`};
   else if (h <= 9.5)
    return {color: `rgb(249,102,0)`};
   else if (h <= 10.0)
    return {color: `rgb(252,70,0)`};
   else if (h <= 11.0)
    return {color: `rgb(254,38,0)`};
   else if (h <= 12.0)
    return {color: `rgb(255,15,4)`};
   else if (h <= 13.0)
    return {color: `rgb(255,14,22)`};
   else if (h <= 14.0)
    return {color: `rgb(255,13,39)`};
   else if (h <= 15.0)
    return {color: `rgb(255,13,56)`};
   else if (h <= 17.0)
    return {color: `rgb(254,12,74)`};
   else if (h <= 20.0)
    return {color: `rgb(254,12,91)`};
   else if (h <= 25.0)
    return {color: `rgb(254,11,109)`};
   else
    return {color: `rgb(253,11,126)`};
}

exports.colorWaveHeight = function(height) {
  const h = parseFloat(height);

  if (h === 0.0)
    return {color: `rgb(0,0,121)`};
  else if (h <= 0.1)
    return {color: `rgb(0,18,117)`};
  else if (h <= 0.2)
    return {color: `rgb(0,37,113)`};
  else if (h <= 0.3)
    return {color: `rgb(0,55,109)`};
  else if (h <= 0.4)
    return {color: `rgb(0,73,105)`};
  else if (h <= 0.5)
    return {color: `rgb(0,92,101)`};
  else if (h <= 0.6)
    return {color: `rgb(0,110,96)`};
  else if (h <= 0.7)
    return {color: `rgb(0,128,92)`};
  else if (h <= 0.8)
    return {color: `rgb(0,147,88)`};
  else if (h <= 0.9)
    return {color: `rgb(0,165,84)`};
  else if (h <= 1.0)
    return {color: `rgb(0,183,80)`};
  else if (h <= 1.1)
    return {color: `rgb(18,192,73)`};
  else if (h <= 1.2)
    return {color: `rgb(41,197,65)`};
  else if (h <= 1.3)
    return {color: `rgb(64,202,58)`};
  else if (h <= 1.4)
    return {color: `rgb(88,207,50)`};
  else if (h <= 1.5)
    return {color: `rgb(111,212,42)`};
  else if (h <= 1.6)
    return {color: `rgb(134,217,35)`};
  else if (h <= 1.7)
    return {color: `rgb(158,222,27)`};
  /*else if (h <= 1.8)
    return {color: `rgb(181,227,19)`};
  else if (h <= 1.9)
    return {color: `rgb(204,232,12)`};
  else if (h <= 2.0)
    return {color: `rgb(228,237,4)`};
  else if (h <= 2.2)
    return {color: `rgb(240,228,0)`};

  else if (h <= 2.4)
    return {color: `rgb(240,204,0)`};
  */
  else if (h <= 2.6)
    return {color: `rgb(240,181,0)`};
  else if (h <= 2.8)
    return {color: `rgb(240,158,0)`};
  else if (h <= 3.0)
    return {color: `rgb(240,134,0)`};
  else if (h <= 3.2)
    return {color: `rgb(240,111,0)`};
  else if (h <= 3.4)
    return {color: `rgb(240,88,0)`};
  else if (h <= 3.6)
    return {color: `rgb(240,64,0)`};
  else if (h <= 3.8)
    return {color: `rgb(240,41,0)`};
  else if (h <= 4.0)
    return {color: `rgb(240,18,0)`};
  else if (h <= 4.5)
    return {color: `rgb(240,0,3)`};
  else if (h <= 5.0)
    return {color: `rgb(240,0,14)`};
  else if (h <= 5.5)
    return {color: `rgb(240,0,25)`};
  else if (h <= 6.0)
    return {color: `rgb(240,0,37)`};
  else if (h <= 7.0)
    return {color: `rgb(240,0,48)`};
  else if (h <= 8.0)
    return {color: `rgb(240,0,59)`};
  else if (h <= 9.0)
    return {color: `rgb(240,0,71)`};
  else if (h <= 10.0)
    return {color: `rgb(240,0,82)`};
  else if (h <= 12.0)
    return {color: `rgb(240,0,93)`};
  else if (h <= 15.0)
    return {color: `rgb(240,0,105)`};
  else
    return {color: `rgb(240,0,116)`};
}

exports.colorWavePerid = function(perid) {
  const h = parseFloat(perid);
  if (h === 0.0)
    return {color: `rgb(0,0,123)`};
  else if (h <= 2.0)
    return {color: `rgb(0,35,112)`};
  else if (h <= 3.0)
    return {color: `rgb(0,69,102)`};
  else if (h <= 4.0)
    return {color: `rgb(0,104,91)`};
  else if (h <= 5.0)
    return {color: `rgb(0,139,81)`};
  else if (h <= 5.5)
    return {color: `rgb(0,174,70)`};
  else if (h <= 6.0)
    return {color: `rgb(22,196,59)`};
  else if (h <= 6.5)
    return {color: `rgb(65,205,47)`};
  else if (h <= 7.0)
    return {color: `rgb(109,215,35)`};
  else if (h <= 7.5)
    return {color: `rgb(152,225,24)`};
  /*else if (h <= 8.0)
    return {color: `rgb(195,234,12)`};
  else if (h <= 8.5)
    return {color: `rgb(239,244,0)`};
    */
  else if (h <= 9.0)
    return {color: `rgb(242,202,0)`};
  else if (h <= 9.5)
    return {color: `rgb(245,161,0)`};
  else if (h <= 10.0)
    return {color: `rgb(248,119,0)`};
  else if (h <= 11.0)
    return {color: `rgb(251,77,0)`};
  else if (h <= 12.0)
    return {color: `rgb(254,36,0)`};
  else if (h <= 14.0)
    return {color: `rgb(255,14,11)`};
  else if (h <= 16.0)
    return {color: `rgb(255,14,34)`};
  else if (h <= 18.0)
    return {color: `rgb(255,13,57)`};
  else if (h <= 20.0)
    return {color: `rgb(254,12,80)`};
  else if (h <= 25.0)
    return {color: `rgb(254,12,103)`};
  else
    return {color: `rgb(253,11,126)`};
}

exports.getDayStr = function(dateStr) {
  const dayJa = dayJaList();
  const day = getYmd(dateStr);

  const date = new Date(day.y, day.m-1, day.d);
  const dayOfWeek = date.getDay();

  return `${day.d}日 ${dayJa[dayOfWeek]}`
}

exports.getDayKey = function(dateStr) {
  const day = getYmd(dateStr);

  return `${day.y}${day.m}${day.d}`
}

function getYmd(dateStr) {
  return {
    y: dateStr.substr( 0, 4 ),
    m: dateStr.substr( 4, 2 ),
    d: dateStr.substr( 6, 2 ),
    h: dateStr.substr( 8, 2 ),
    mi: dateStr.substr( 10, 2 ),
  };
}

function dayJaList() {
  return [ "(日)", "(月)", "(火)", "(水)", "(木)", "(金)", "(土)" ]
}